import { pick } from 'lodash'

export function CallAction({ children, type, className, ...props }) {
    type = type || 'button'
    props = pick(props, ['onClick', 'disabled', 'data-button-id'])
    return (
        <button
            {...props}
            type={type}
            className={`p-3 bg-olm-green rounded text-white text-sm ${className}`}>
            {children}
        </button>
    )
}
